// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"324":"a230a9c8","899":"078feabb"}[chunkId] + ".chunk.css";
};